import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import { ComponentsModule } from '../components/components.module';
import { ErrorsRoutes } from './errors.routing';
import {
  IdentificationFailedComponent,
  InvalidSessionComponent,
  PageNotFoundComponent,
  RequestFailedComponent,
  RequestFailedHelpComponent,
  InvalidTokenComponent,
  ChangePasswordFailedComponent
} from '.';


@NgModule({
  declarations: [
    IdentificationFailedComponent,
    InvalidSessionComponent,
    PageNotFoundComponent,
    RequestFailedComponent,
    RequestFailedHelpComponent,
    InvalidTokenComponent,
    ChangePasswordFailedComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    ErrorsRoutes
  ],
  exports: [
    RouterModule,
    IdentificationFailedComponent,
    InvalidSessionComponent,
    PageNotFoundComponent,
    RequestFailedComponent,
    RequestFailedHelpComponent,
    InvalidTokenComponent,
    ChangePasswordFailedComponent
  ]
})
export class ErrorsModule { }
